import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/canonical.service';
import { CountryService } from 'src/app/country.service';
import { CommunicationService } from 'src/app/communication.service';
@Component({
  selector: 'app-home',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  country = 'sg';
  //   opened = [];
  //   titleMain = true;
  //   faqItems = [          
  //     {
  //       "head":"General",
  //       "title": "Am I eligible to sign up?",
  //     "description": "If you are a resident of Singapore, you can sign up with us. Itâ€™s simple and free, so start now."},
  //     {
  //           "title": "Which countries can I transfer money to?",
  //     "description": " "},
  //     {
  //           "title": "How much does it cost?",
  //     "description": " "},
  //     {
  //           "title": "How long does it take?",
  //     "description": " "},
  //     {
  //           "title": "Is my money safe?",
  //     "description": " "},
  //     {
  //           "title": "How do I sign up?",
  //     "description": " "},
  //     {
  //           "title": "How do I make a transaction?",
  //     "description": " "},
  //     {
  //           "title": "How much can I send?",
  //     "description": " "},
  //     {
  //           "title": "How can I contact SingX?",
  //     "description": " "},
  //     {
  //           "title": "Bank Holidays?",
  //     "description": " "},
  //     {
  //           "title": "Why should I use SingX?",
  //     "description": " "},
  //     {
  //           "title": "Which countries can I transfer money from?",
  //     "description": " "},
  //     {
  //       "head": "Basic Information",
  //           "title": "Why should I use SingX?",
  //     "description": " "},
  //     {
  //           "title": "Which countries can I transfer money from?",
  //     "description": " "},
  //     {
  //       "head":"Signing Up",
  //           "title": "What is the registration process?",
  //     "description": " "},
  //     {
  //           "title": "What documents are required?",
  //     "description": " "},
  //     {
  //           "title": "Does it cost anything to register with SingX?",
  //     "description": " "},
  //     {
  //           "head":"Signing Up Using MyInfo"},
  //     {
  //           "title": "What is MyInfo?",
  //     "description": " "},
  //     {
  //           "title": "What type of transactions can I perform with SingX using MyInfo services?",
  //     "description": " "},
  //     {
  //           "title": "Am I required to register for MyInfo?",
  //     "description": " "},
  //     {
  //           "title": "Am I required to upload any documents using MyInfo?",
  //     "description": " "},
  //     {
  //           "title": "What type of personal data will SingX be accessing from MyInfo?",
  //     "description": " "},
  //     {
  //           "title": "Can I choose which data I want to share with SingX?",
  //     "description": " "},
  //     {
  //           "title": "Will SingX be able to use my data for other purposes besides processing my application?",
  //     "description": " "},
  //     {
  //           "title": "The data pre-filled by MyInfo in the application form is incorrect. How can I update the data?",
  //     "description": " "},
  //     {
  //           "title": "If there is any change in my information post account opening, will SingX automatically update my records using MyInfo?",
  //     "description": " "},
  //     {
  //       "head":"Remittance",
  //           "title": "Rates, Charges & Savings",
  //     "description": " "},
  //     {
  //           "title": "What are the real savings?",
  //     "description": " "},
  //     {
  //           "title": "Will I be charged any fees/charges other than what I see in the Fair Exchange Calculator?",
  //     "description": " "},
  //     {
  //           "title": "How do your charges compare with the banks?",
  //     "description": " "},
  //     {
  //           "title": "How does your rate compare with Western Union or other money transfer operators?",
  //     "description": " "},
  //     {
  //           "title": "Create A Transfer Request",
  //     "description": " "},
  //     {
  //           "title": "How do I pay for the transfer?",
  //     "description": " "},
  //     {
  //           "title": "How can I schedule money transfers on a monthly or periodic basis?",
  //     "description": " "},
  //     {
  //           "title": "Can I add more than one of my bank accounts to my SingX account?",
  //     "description": " "},
  //     {
  //           "title": "Can I send money from my spouseâ€™s or family memberâ€™s bank account to a receiverâ€™s account?",
  //     "description": " "},
  //     {
  //           "title": "Can I transfer money from a joint bank account?",
  //     "description": " "},
  //     {
  //           "title": "Can my receiver receive money in cash?",
  //     "description": " "},
  //     {
  //           "title": "Where can my recipient collect the funds in the Philippines?",
  //     "description": " "},
  //     {
  //           "title": "When will funds be available for collection in the Philippines?",
  //     "description": " "},
  //     {
  //           "title": "How long does the receiver have to pick up the cash?",
  //     "description": " "},
  //     {
  //           "title": "What information do I need from my recipient to pick up cash in the Philippines?",
  //     "description": " "},
  //     {
  //           "title": "Will I get a FIRC for the money I transfer to India?",
  //     "description": " "},
  //     {
  //           "title": "Troubleshoot Active Transactions",
  //     "description": " "},
  //     {
  //           "title": "My receiver has not received the money. What do I do?",
  //     "description": " "},
  //     {
  //           "title": "Will my transaction expire? How long is my transaction valid?",
  //     "description": " "},
  //     {
  //           "title": "Will I get some sort of proof of the transaction?",
  //     "description": " "},
  //     {
  //           "title": "I forgot the reference number of my transaction. What do I do?",
  //     "description": " "},
  //     {
  //           "title": "Why did my transaction fail?",
  //     "description": " "},
  //     {
  //           "title": "My transaction has failed. How do I get my money back?",
  //     "description": " "},
  //     {
  //           "title": "What does â€˜validityâ€™ of a transaction mean?",
  //     "description": " "},
  //     {
  //           "title": "I have sent money to your account, but status still shows as â€˜Processingâ€™. What does this mean?",
  //     "description": " "},
  //     {
  //           "title": "I raised a transaction on late Friday evening. When will the transaction get completed?",
  //     "description": " "},
  //     {
  //           "title": "How can I cancel my transaction?",
  //     "description": " "},
  //     {
  //           "title": "Payment",
  //     "description": " "},
  //     {
  //           "title": "How do I pay by bank transfer?",
  //     "description": " "},
  //     {
  //           "title": "Can I pay by cheque, cash or card?",
  //     "description": " "},
  //     {
  //           "title": "What about joint bank accounts?",
  //     "description": " "},
  //     {
  //           "title": "What is the unique transaction number?",
  //     "description": " "},
  //     {
  //           "title": "In my bankâ€™s screen for making an online payment, there is no place to put in a Transaction Reference Number. What do I do?",
  //     "description": " "},
  //     {
  //           "title": "I have created two transactions, but a bank transfer for one of them. How do I let you know which transaction I want to proceed with?",
  //     "description": " "},
  //     {
  //           "title": "SingX Wallet",
  //     "description": " "},
  //     {
  //           "title": "How do I top up my wallet balance",
  //     "description": " "},
  //     {
  //           "title": "Is there a top up limit",
  //     "description": " "},
  //     {
  //           "title": "Why should I use the SingX wallet?",
  //     "description": " "},
  //     {
  //           "title": "Are there any additional charges when I pay with the wallet?",
  //     "description": " "},
  //     {
  //           "title": "Is there a limit to the number of transactions that I can make with my Wallet?",
  //     "description": " "},
  //     {
  //           "title": "Will the top-up be instantaneous?",
  //     "description": " "},
  //     {
  //           "title": "Can I refund the remaining value in my Wallet?",
  //     "description": " "},
  //     {
  //           "title": "Bill Payments (India)",
  //     "description": " "},
  //     {
  //           "title": "How To Pay Billsâ€¯in Indiaâ€¯Online",
  //     "description": " "},
  //     {
  //           "title": "What payment options are available to make Bill Payments onâ€¯SingX?",
  //     "description": " "},
  //     {
  //           "title": "DTH",
  //     "description": " "},
  //     {
  //           "title": "How long does it take to process DTH Recharge Online?",
  //     "description": " "},
  //     {
  //           "title": "Doesâ€¯SingXâ€¯support all operators for DTH rechargeâ€¯plans ?",
  //     "description": " "},
  //     {
  //           "title": "How to check DTH balance online?",
  //     "description": " "},
  //     {
  //           "title": "Electricity",
  //     "description": " "},
  //     {
  //           "title": "Which operators are available for Electricity Bill Payments?",
  //     "description": " "},
  //     {
  //           "title": "BroadBand",
  //     "description": "Broadband is high speed internet connection enabled through different mediums. Broadband bill payment can be easily done online in an instant. Online broadband bill payment ensures instant bill payment and uninterrupted internet services."},

  //     {
  //           "title": "",
  //     "description": " "},
  //     {
  //           "title": "How long does it take to process the Broadband Bill Payment?",
  //     "description": " "},
  //     {
  //           "title": "Doesâ€¯SingXâ€¯support all operators for Broadband Bill Payment?",
  //     "description": " "},
  //     {
  //           "title": "Credit Cards",
  //     "description": "Credit card allows users to avail short term credit from their banks for immediate payments. For credit card users it is very important to remember the credit card bill date. The user shall clear the dues monthly. If usersâ€¯donâ€™tâ€¯make their Credit Card Payment on time, they are charged with interest. Further, untimely payment of the credit card bill also leads to late fee.â€¯In order toâ€¯avoid unnecessary late fees and interest on credit card processing, users can instantly make their online credit card payment usingâ€¯SingX."},    

  //     {
  //           "title": "For Visa,â€¯SingXâ€¯allows Credit Card Payment of all banks. For any other, bill payment of only the following cards can be made.",
  //     "description": " "},
  //     {
  //           "title": "Can I only pay the minimum due amount?â€¯",
  //     "description": " "},
  //     {
  //           "title": "Do I need to pay my credit card in full?",
  //     "description": " "},
  //     {
  //           "title": "When should I pay my credit card bill?â€¯",
  //     "description": " "},
  //     {
  //           "title": "Does late payment affect my credit Score?",
  //     "description": " "},
  //     {
  //           "title": "Cable",
  //     "description": " "},
  //     {
  //           "title": "Cable connection usually needs monthly cable bill payment to ensure seamless cable connectivity.",
  //     "description": " "},
  //     {
  //           "title": "Global Mobile Top Ups",
  //     "description": " "},
  //     {
  //           "title": "What can I do with this service?",
  //     "description": " "},
  //     {
  //           "title": "What countries does SingX serve?",
  //     "description": " "},
  //     {
  //           "title": "What is top up?",
  //     "description": " "},
  //     {
  //           "title": "How do I send a Top up?",
  //     "description": " "},
  //     {
  //           "title": "Do I have to create an account to use this service?",
  //     "description": " "},
  //     {
  //           "title": "Why I am receiving am OTP?",
  //     "description": " "},
  //     {
  //           "title": "Do I have to log in to my account each time I want to send credit?",
  //     "description": " "},
  //     {
  //           "title": "Can I send top-up/credit to any mobile number?",
  //     "description": " "},
  //     {
  //           "title": "What will happen if I try to top-up a phone number that is not supported?",
  //     "description": " "},
  //     {
  //           "title": "How much top up amount can I send?",
  //     "description": " "},
  //     {
  //           "title": "How can I know if the top up has been received by the recipient?",
  //     "description": " "},
  //     {
  //           "title": "I received a confirmation SMS, but my contact says he/she hasnâ€™t received the credit",
  //     "description": " "},
  //     {
  //           "title": "How much time does it take for the top up to show up on my contact's account?",
  //     "description": " "},
  //     {
  //           "title": "I sent credit to a wrong number by mistake, can I cancel the transaction?",
  //     "description": " "},
  //     {
  //           "title": "What are the different payment means available?",
  //     "description": " "},
  //     {
  //           "title": "How can I be sure the transfer has been successful?",
  //     "description": " "},
  //     {
  //           "title": "Can I send Top up to more than one mobile number?",
  //     "description": " "},
  //     {
  //           "title": "What is the cost to send a Top up?",
  //     "description": " "},
  //     {
  //           "title": "What happens if my SingX Wallet is charged and I do not receive the Top up?",
  //     "description": " "},
  //     {
  //           "title": "What is the exchange rate while conducting a mobile top up transactions?",
  //     "description": " "},
  //     {
  //           "title": "Account Management",
  //     "description": " "},
  //     {
  //           "title": "How do I edit profile details?",
  //     "description": " "},
  //     {
  //           "title": "How do I change my password?",
  //     "description": " "},
  //     {
  //           "title": "How do I change my email address?",
  //     "description": " "},
  //     {
  //           "title": "How do I change my mobile number?",
  //     "description": " "},
  //     {
  //           "title": "How do I add/delete my receiverâ€™s bank account?",
  //     "description": " "},
  //     {
  //           "title": "How do I add/delete my (sender) bank account?",
  //     "description": " "},
  //     {
  //           "title": "What details do I need to add a receiverâ€™s account?",
  //     "description": " "},
  //     {
  //           "title": "Technical & Browser Queries",
  //     "description": " "},
  //     {
  //           "title": "What Internet browsers do you support?",
  //     "description": " "},
  //     {
  //           "title": "How do I enable cookies?",
  //     "description": " "},
  //     {
  //           "title": "How do I clear my cache?",
  //     "description": " "},
  //     {
  //           "title": "How do I take a screenshot?",
  //     "description": " "},
  //     {
  //           "title": "Which Internet browser works best for SingX?",
  //     "description": " "},
  //     {
  //           "title": "Is my personal data safe?",
  //     "description": " "},
  //     {
  //           "title": "Rate Alert",
  //     "description": " "},
  //     {
  //           "title": "Do I need to register with SingX to create a rate alert?",
  //     "description": " "},
  //     {
  //           "title": "Does it cost me anything to setup a rate alert?",
  //     "description": " "},
  //     {
  //           "title": "What are the different types of rate alert that SingX offers?",
  //     "description": " "},
  //     {
  //           "title": "Can I set multiple rate alerts for the same currency pair? (i.e. Three different rate alerts for SGD to INR)",
  //     "description": " "},
  //     {
  //           "title": "Can I receive the same rate alert via both SMS and Email?",
  //     "description": " "},
  //     {
  //           "title": "Does the foreign exchange rate involve any markups?",
  //     "description": " "},
  //     {
  //           "title": "Will you hold the foreign exchange rate that I receive via the rate alert email/SMS notification for me to transact at?",
  //     "description": " "},
  //     {
  //           "title": "How many times will I receive alerts if the foreign exchange rate exceeds the limit that I set? (i.e. I set up an alert if 1 SGD crosses 46 INR)",
  //     "description": " "},
  //     {
  //           "title": "How does a two-week high alert work?",
  //     "description": " "},
  //     {
  //           "title": "How can I edit my existing alerts?",
  //     "description": " "},
  //     {
  //           "title": "How many times will I receive rate alerts in one day?",
  //     "description": " "},
  //     {
  //           "title": "How do I unsubscribe from the rate alerts?",
  //     "description": " "},
  //     {
  //           "title": "Can I share the rate alert with my friends?",
  //     "description": " "},
  //     {
  //           "title": "Who can I contact if I still have questions?",
  //     "description": " "}
  //   ];

  constructor(private meta: Meta, private title: Title, private cs: CountryService, private canonicalService: CanonicalService, private communicationService: CommunicationService) {

    // this.title.setTitle("International Money Transfer - FAQ | SingX");
    // this.meta.addTags([
    //   { name: 'description', content: 'Frequently Asked Questions for International Money Transfer and Business Payment like account sign up, rates, savings, transactions, security and more.' },
    //   { name: 'author', content: 'SingX' },
    //   { name: 'keywords', content: 'Money to India Exchange Rate, best money transfer to India, how to transfer money to India, best way to Send Money Overseas, remit to India rates, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' }
    // ]);
  }


  ngOnInit(): void {
    this.country = this.cs.getCountry();
    if (this.country === 'sg') {
      this.title.setTitle("International Money Transfer - FAQ | SingX");
      this.canonicalService.updateCanonicalUrl('/faq');
      this.meta.updateTag({ name: 'description', content: 'Frequently Asked Questions for International Money Transfer and Business Payment like account sign up, rates, savings, transactions, security and more.' })
      this.meta.updateTag({ name: 'author', content: 'SingX' })
      this.meta.updateTag({ name: 'keywords', content: 'Money to India Exchange Rate, best money transfer to India, how to transfer money to India, best way to Send Money Overseas, remit to India rates, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' })
      // this.meta.addTags([
      //   { name: 'description', content: 'Frequently Asked Questions for International Money Transfer and Business Payment like account sign up, rates, savings, transactions, security and more.' },
      //   { name: 'author', content: 'SingX' },
      //   { name: 'keywords', content: 'Money to India Exchange Rate, best money transfer to India, how to transfer money to India, best way to Send Money Overseas, remit to India rates, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' }
      // ], true);
    } else if (this.country === 'hk') {
      this.title.setTitle("Frequently Asked Questions (FAQs) - SingX");
      this.canonicalService.updatehkCanonicalUrl('/faq');
      this.meta.updateTag({ name: 'description', content: 'SingX helps you to Transfer Money Internationally from Hong Kong and Frequently Asked Questions on Account Sign Up, Rates, Savings, Transactions, Security and many more.' })
      this.meta.updateTag({ name: 'author', content: 'SingX' })
      this.meta.updateTag({ name: 'keywords', content: 'Money Transfer from Hong Kong, Money Transfer Overseas, Money Transfer Globally, International Money Transfer, International Business Payment, Fund Transfer Overseas, International Remittance, Money Exchangers.' })
    }
    else if (this.country === 'au') {
      this.title.setTitle("Frequently Asked Questions (FAQs) - SingX");
      this.canonicalService.updateauCanonicalUrl('/faq');
      this.meta.updateTag({ name: 'description', content: 'SingX helps you to Transfer Money Internationally from Australia and Frequently Asked Questions on Account Sign Up, Rates, Savings, Transactions, Security and many more.' })
      this.meta.updateTag({ name: 'author', content: 'SingX' })
      this.meta.updateTag({ name: 'keywords', content: 'International Money Transfer from Australia, Money Transfer Overseas, Global Money Transfer, International Fund Transfer, International Remittance, Remit Money Overseas, Foreign Remittance, International Payment Transfer.' })
    } else {
      this.title.setTitle("International Money Transfer - FAQ | SingX");
      this.meta.addTags([
        { name: 'description', content: 'Frequently Asked Questions for International Money Transfer and Business Payment like account sign up, rates, savings, transactions, security and more.' },
        { name: 'author', content: 'SingX' },
        { name: 'keywords', content: 'Money to India Exchange Rate, best money transfer to India, how to transfer money to India, best way to Send Money Overseas, remit to India rates, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' }
      ], true);
    }
  }


  redirectToRegistrationPage() {
    this.communicationService.sendMessage("redirectToRegistrationPage", true);
  }

}
